import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router";
import "./views/Landing.css";
import Eventos from "./views/Eventos";
import Financeiro from "./views/Financeiro";
import MinhasCorridas from "./views/corredor/MinhasCorridas";
import Login from "./views/Login";
import NovasCorridas from "./components/corredor/NovasCorridas";
import Sucesso from "./views/payment/SucessoPay";
import PerfilUsuario from "./views/PerfilUsuario";
import Teste from "./views/Teste";
import ComoFunciona from "./views/ComoFunciona";
import Recursos from "./views/Recursos";
import ParaOrganizadores from "./views/ParaOrganizadores";
import ParaAtletas from "./views/ParaAtletas";
import Contato from "./views/Contato";
import Home from "./views/Home";
import CompletarPerfil from "./views/CompletarPerfil";
import PoliticaPrivacidade from "./views/PoliticaPrivacidade";
import TermosServico from "./views/TermosServico";
import Pendente from "./views/payment/PendentePay";
import Falha from "./views/payment/FalhaPay";
import SolicitarRecuperacaoSenha from "./views/SolicitarRecuperacaoSenha";
import RedefinirSenhaConfirmacao from "./views/RedefinirSenhaConfirmacao";
import StaffDashboard from "./views/staff/StaffDashboard";
import CheckoutView from "./views/CheckoutView";
import StravaCallbackPage from "./views/StravaCallbackPage";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CLIENT_ID_GOOGLE } from "./services/config";
import { LojaCartProvider } from "./context/LojaCartContext";
import LojaUrbView from "./views/loja/LojaUrbView";
import LojaCheckoutView from "./views/loja/LojaCheckoutView";
import LojaPedidoView from "./views/loja/LojaPedidoView";
import LojaAdminView from "./views/loja/LojaAdminView";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={CLIENT_ID_GOOGLE}>
            <LojaCartProvider>
                <BrowserRouter>
                    <Routes>
                    <Route path={"/"} element={<Home/>}/>
                    <Route path={"/login"} element={<Login/>}/>
                    <Route path={"/solicitar-recuperacao"} element={<SolicitarRecuperacaoSenha/>}/>
                    <Route path={"/reset-password"} element={<RedefinirSenhaConfirmacao/>}/>
                    <Route path={"/dashboard"} element={<App/>}/>
                    <Route path={"/staff-dashboard"} element={<StaffDashboard/>}/>
                    <Route path={"/eventos"} element={<Eventos/>}/>
                    <Route path={"/financeiro"} element={<Financeiro/>}/>
                    <Route path={"/financeiro-brv"} element={<Financeiro/>}/>
                    <Route path={"/minhas-corridas"} element={<MinhasCorridas/>}/>
                    <Route path={"/novas-corridas"} element={<NovasCorridas/>}/>
                    <Route path={"/checkout/:id"} element={<CheckoutView/>}/>
                    <Route path={"/pagamento/sucesso"} element={<Sucesso/>}/>
                    <Route path={"/pagamento/pendente"} element={<Pendente/>}/>
                    <Route path={"/pagamento/falha"} element={<Falha/>}/>
                    <Route path={"/pagamento/sucesso/teste"} element={<Teste/>}/>
                    <Route path={"/perfil"} element={<PerfilUsuario/>}/>
                    <Route path={"/perfil/strava-conectado"} element={<StravaCallbackPage/>}/>
                    <Route path={"/strava/callback"} element={<StravaCallbackPage/>}/>
                    <Route path={"/completar-perfil"} element={<CompletarPerfil/>}/>
                    <Route path={"/como-funciona"} element={<ComoFunciona/>}/>
                    <Route path={"/recursos"} element={<Recursos/>}/>
                    <Route path={"/para-organizadores"} element={<ParaOrganizadores/>}/>
                    <Route path={"/para-atletas"} element={<ParaAtletas/>}/>
                    <Route path={"/contato"} element={<Contato/>}/>
                    <Route path={"/politica-privacidade"} element={<PoliticaPrivacidade/>}/>
                    <Route path={"/termos-servico"} element={<TermosServico/>}/>
                    {/* Rotas Oficiais Loja URB */}
                    <Route path={"/loja"} element={<LojaUrbView/>}/>
                    <Route path={"/loja/checkout"} element={<LojaCheckoutView/>}/>
                    <Route path={"/loja/pedido/:numero"} element={<LojaPedidoView/>}/>
                    <Route path={"/loja/admin"} element={<LojaAdminView/>}/>
                </Routes>
            </BrowserRouter>
        </LojaCartProvider>
    </GoogleOAuthProvider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
